import * as React from 'react';
import { clsx } from 'clsx';

import * as style from '../../style.css';

export interface ITableCellProps {
  children: React.ReactNode;
  pinned: boolean;
  /** Ref для FLIP-анимации закрепления, см. usePinFlipAnimation. */
  cellRef: React.Ref<HTMLDivElement>;
}

export const TableCell = ({ children, pinned, cellRef }: ITableCellProps) => (
  <div ref={cellRef} className={clsx(style['cell'], pinned && style['cell-pinned'])} role="cell">
    {children}
  </div>
);
